module.exports = __webpack_public_path__ + "static/allendrew-a2f140bf4a62f747c4e8614d195ecd86.jpg";